// extracted by mini-css-extract-plugin
module.exports = {"_frame":"Marktcharts__frame__19FDi"};